import { Box, Grid, IconButton } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { get, isNil, isString, pick } from 'lodash';
import styled from '@emotion/styled';
import Button from '../components/Button';
import CustomInput from 'components/fields/input2';
import CustomCheckbox from 'components/fields/CustomCheckbox';
import Modal from 'components/modal/modal';
import DatePickerCalendar from './DatePickerCalendar';
import CustomAutocomplete from 'components/AutoComplete';
import { ReactComponent as CloseIcon } from '../assets/img/Close_round_gray.svg';
import SwitchTab from './switch-tab';
import Flex from './Flex';
import MultiPricePopup from './MultiPricePopup';
import { toast } from 'react-toastify';
import { dayOfWeeks } from 'utils/constants';

const Styled = styled.div`
    .checkbox-div {
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;
        margin-top: 10px;
        label {
            flex-direction: row;
        }
    }

    .modal__body {
        display: flex !important;
        max-height: 95vh;
        width: 90% !important;
        max-width: 1000px;
        overflow: auto;
        background: #f9faff !important;
        padding: 25px 40px !important;
        border-radius: 10px;
        background: #f9faff !important;
    }

    form {
        display: flex !important;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .title {
            font-weight: 600;
            font-size: 18px;
            line-height: 22px;
            color: #262626;
            margin-bottom: 10px;
        }
        .input {
        }
        .close-d {
            width: 100%;
            display: flex;
            justify-content: end;
            margin-bottom: 30px;
        }
    }
    .MuiChip-label {
        max-width: fit-content !important;
    }
    @media only screen and (max-width: 900px) {
        .modal__body {
            padding: 15px 20px !important;
        }
    }
`;

const valueName = {
    ROOMS_FOR_SALE: 'availableRooms',
    MINIMUM_STAY_DAYS: 'minimumStayDays',
    PRICE: 'price',
    ROOM_STATUS: 'roomStatus',
};

const ModalCalendar = ({
    isOpen,
    hide,
    activeCategoryId,
    date = {},
    onSubmit: onDataSubmit = () => '',
    categories = [],
    t = () => '',
    modalType = '',
}) => {
    const [btnLoading, setBtnLoading] = useState(false);
    const [active, setActive] = useState(true);
    const [rangeDate, setRangeDate] = useState(date);
    const submitButton = useRef(null);
    const [selectedCategories, setSelectedCategories] = useState([]);

    const defaultValues = {
        value: '',
        categoryIds: [],
    };

    const {
        handleSubmit,
        register,
        control,
        setValue,
        clearErrors,
        getValues,
        formState: { errors },
        reset,
    } = useForm({ defaultValues });

    const handleHide = () => {
        setRangeDate(date);
        setActive(true);
        reset();
        clearErrors();
        hide();
    };

    const clickSubmit = () => {
        setValue('valueType', 'PRICE_BY_GUEST');
        submitButton.current.click();
    };

    const onSubmit = (formValues) => {
        setBtnLoading(true);
        let type = formValues.valueType || modalType;
        if (type === 'ALL') formValues.value.roomStatus = active;
        else if (type === 'ROOM_STATUS') formValues.value = { roomStatus: active };
        else if (type === 'PRICE_BY_GUEST') {
            const arr = [];
            formValues.value.priceByGuests?.forEach((value, index) => value && arr.push({ numberOfGuest: index + 1, price: value }));
            formValues.value.priceByGuests = arr;
        } else {
            if (!isString(formValues.value) || !formValues.value) {
                toast.warning(t(type + '_IS_REQUIRED'));
                return setBtnLoading(false);
            }
            const value = { [valueName[type]]: formValues.value };
            formValues.value = value;
        }

        const dayOfWeeks = [];
        for (const key in formValues?.dayOfWeeks) {
            if (get(formValues, `dayOfWeeks.${key}`)) dayOfWeeks.push(key);
        }

        formValues.dayOfWeeks = dayOfWeeks;
        formValues.valueType = type;
        formValues.categoryIds = formValues.categoryIds.map((item) => item.id);
        formValues.from = rangeDate.from;
        formValues.to = rangeDate.to;

        onDataSubmit(formValues, (isSuccess) => {
            setBtnLoading(false);
            if (!isSuccess) return;

            if (type === 'PRICE_BY_GUEST') {
                setValue('valueType', modalType);
            } else handleHide();
            setBtnLoading(false);
        });
    };

    useEffect(() => {
        if (!isOpen) return;
        const category = categories?.find((c) => c.categoryId === activeCategoryId);
        category.id = category.categoryId;
        category.amountOfRooms = isNil(category.amountOfRooms) ? 10000 : category.amountOfRooms;

        if (category) {
            setValue('categoryIds', [pick(category, ['id', 'name', 'maxNumberOfGuest', 'amountOfRooms'])]);
            setSelectedCategories([category]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    useEffect(() => {
        setRangeDate(date);
    }, [date]);

    return (
        <Styled>
            <Modal active={isOpen} onClose={handleHide}>
                <form onSubmit={handleSubmit(onSubmit)} className="dialog-form">
                    <Flex justify={'flex-end'}>
                        <IconButton onClick={handleHide}>
                            <CloseIcon />
                        </IconButton>
                    </Flex>
                    <div className="label">{t('CATEGORIES')}</div>
                    <CustomAutocomplete
                        multiple
                        limitTags={100}
                        id="multiple-limit-tags"
                        name="categoryIds"
                        control={control}
                        style={{ marginBottom: '24px' }}
                        rules={{
                            required: {
                                value: true,
                                message: t('CATEGORY') + ' ' + t('IS_REQUIRED'),
                            },
                        }}
                        options={categories.map((item) => ({
                            name: item.name,
                            id: item.categoryId,
                            maxNumberOfGuest: item.maxNumberOfGuest,
                            amountOfRooms: isNil(item.amountOfRooms) ? 10000 : item.amountOfRooms,
                        }))}
                        onSelect={(categories) => {
                            if (getValues('value.priceByGuests') && modalType !== 'PRICE_BY_GUEST') {
                                setValue('value.priceByGuests', []);
                            }
                            setSelectedCategories(categories);
                        }}
                    />
                    {modalType === 'ROOM_STATUS' ? (
                        <SwitchTab yes={t('ACTIVE')} no={t('NO_ACTIVE')} value={active} onChange={(value) => setActive(value)} />
                    ) : modalType !== 'ALL' ? (
                        <Box display={'flex'} gap={'10px'} alignItems={'center'}>
                            <div>
                                <div className="label">{t(modalType)}</div>
                                <CustomInput
                                    name="value"
                                    type="number"
                                    style={{ maxWidth: '140px' }}
                                    rules={{
                                        required: {
                                            value: modalType !== 'PRICE',
                                            message: t('VALUE_IS_REQUIRED'),
                                        },
                                        min: {
                                            value: 0.001,
                                            message: t('VALUE_MUST_BE_GREATER_THAN_ZERO'),
                                        },
                                        // max:
                                        //     modalType === 'ROOMS_FOR_SALE'
                                        //         ? {
                                        //               value: min(selectedCategories.map((c) => c.amountOfRooms)),
                                        //               message: t('VALUE_MUST_BE_LESS_THAN_{value}', {
                                        //                   value: min(selectedCategories.map((c) => c.amountOfRooms)),
                                        //               }),
                                        //           }
                                        //         : undefined,
                                    }}
                                    control={control}
                                />
                            </div>
                            {modalType === 'PRICE' && (
                                <MultiPricePopup
                                    {...{
                                        selectedCategories,
                                        clickSubmit,
                                        errors,
                                        register,
                                        t,
                                    }}
                                />
                            )}
                        </Box>
                    ) : (
                        <Grid columnSpacing={2} container>
                            <Grid xs={12} item>
                                <SwitchTab yes={t('ACTIVE')} no={t('NO_ACTIVE')} value={active} onChange={(value) => setActive(value)} />
                            </Grid>
                            {['PRICE', 'MINIMUM_STAY_DAYS'].map((field) => (
                                <Grid key={field} xs={12} md={4} item>
                                    <div className="label">{t(field)}</div>
                                    <CustomInput
                                        name={`value.${valueName[field]}`}
                                        type="number"
                                        rules={{
                                            required: {
                                                value: true,
                                                message: t(field) + ' ' + t('IS_REQUIRED'),
                                            },
                                            min: {
                                                value: 0.001,
                                                message: t('VALUE_MUST_BE_GREATER_THAN_ZERO'),
                                            },
                                            // max:
                                            //     field === 'ROOMS_FOR_SALE'
                                            //         ? {
                                            //               value: min(selectedCategories.map((c) => c.amountOfRooms)),
                                            //               message: t('VALUE_MUST_BE_LESS_THAN_{value}', {
                                            //                   value: min(selectedCategories.map((c) => c.amountOfRooms)),
                                            //               }),
                                            //           }
                                            //         : undefined,
                                        }}
                                        control={control}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    )}
                    <div className="label">{t('CHOOSE_PERIOD')}</div>
                    <DatePickerCalendar
                        {...rangeDate}
                        onChange={(date) => {
                            setRangeDate({
                                from: moment(date.fromDate).format('YYYY-MM-DD'),
                                to: moment(date.toDate).format('YYYY-MM-DD'),
                            });
                        }}
                    />
                    <div style={{ marginTop: '24px' }} className="checkbox-div">
                        {dayOfWeeks.map((item) => {
                            return (
                                <CustomCheckbox
                                    key={item.name}
                                    sx={{ mb: 0.5 }}
                                    defaultValue={true}
                                    label={t(`${item.name}`)}
                                    name={`dayOfWeeks.${item.name}`}
                                    control={control}
                                />
                            );
                        })}
                    </div>
                    <Box display={'flex'} marginTop={'15px'} gap="15px">
                        <Button
                            onClick={handleHide}
                            style={{
                                margin: '0px 0',
                                background: 'white',
                                color: '#0d8ceb',
                                border: '1px solid  #0d8ceb',
                            }}
                        >
                            {t('CANCEL')}
                        </Button>
                        <Button loading={btnLoading} type="submit" style={{ margin: '0px 0' }}>
                            {t('SAVE')}
                        </Button>
                        <button ref={submitButton} type="submit" className="d-none" />
                    </Box>
                </form>
            </Modal>
        </Styled>
    );
};

export default ModalCalendar;
